export default __webpack_public_path__ + "static/uiux-elevating-36e8a06ed6869ad3dac1a9bb23b10d15.png";